export const reportMessages = {
  progress: 'Report generation is still in progress. Are you sure you want to continue?',
};
